/// <amd-module name="TFS/CreateProject/Constants" />
export namespace Constants {
    export const Area = "CreateProjectPanel";
    export const ProjectCreationDataProvider = "ms.vss-tfs-web.create-project-data-provider";
    export const ProjectNamesDataProvider = "ms.vss-tfs-web.project-names-data-provider";
    export const ProjectOverviewRoute = "ms.vss-tfs-web.project-overview-route";
    export const OrganizationSecurityRoute = "ms.vss-admin-web.organization-admin-security-route";
    export const MembersActionParam = "members";
    export const DefafultProcessTemplate = "860fc3a4-aaeb-42b9-a8ec-8d2c189b106c";
    export const DisableProjectLimitFeatureFlag = "Project.Creation.DisableProjectLimitCheck";
    export const ProjectLimitSharedDataName = "ProjectLimitFromRegistry";
    export const ProjectWarningSharedDataName = "ProjectWarningFromRegistry";
    export const DisablePerformanceWarningFeatureFlag = "Project.Creation.DisableProjectPerformanceWarning";
    export const NewCreateProjectPanelErrorMessageCard = "Project.Creation.NewCreateProjectPanelErrorMessageCard";
}

export namespace ProjectParameterConstants {
    export const MaxProjectNameLength = 64;
    export const MaxProjectDescriptionLength = 15999;
}

// Copied these constants from "Tfs/Service/WebAccess/Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants.ts" to use in this webproj
export namespace ProjectVisibilityConstants {
    export const EveryoneInTenant = "EveryoneInTenant";
    export const TeamMembers = "TeamMembers";
    export const Everyone = "Everyone";
}
